var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgECommerce2Line75(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "e-commerce_2-line-75") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 23.5h3.5v-1h-3.5v-3.5h-1v11.5h4.5v-1h-3.5zM29.75 29.5h-3v-2.5h-1v2.5h-2.5v1h7.5v-6.5h-1zM29.75 21h1v2h-1v-2zM29.75 16h1v4h-1v-4zM26.3 16.15h1.55v1h-1.55v-1zM22.25 20.5h5v1h-5v-1zM12.75 0.5h-12v12h12v-12zM11.75 11.5h-10v-10h10v10zM0.75 31.5h12v-12h-12v12zM1.75 20.5h10v10h-10v-10zM19.75 0.5v12h12v-12h-12zM30.75 11.5h-10v-10h10v10zM5.75 5.5h2v2h-2v-2zM5.75 24.5h2v2h-2v-2zM24.75 5.5h2v2h-2v-2zM0.75 15.5h4v1h-4v-1zM6.25 15.5h7v1h-7v-1zM15.75 11h1v2h-1v-2zM15.75 8h1v2h-1v-2zM15.75 2h1v4h-1v-4zM17.25 17.5h2v1h-2v-1zM19.25 15.5h2v1h-2v-1zM20.25 25.5h2v1h-2v-1zM23.25 23.5h2v1h-2v-1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgECommerce2Line75);
export default __webpack_public_path__ + "static/media/e-commerce_2-line-75.d3a95d36d365b344854d770a0a75539f.svg";
export { ForwardRef as ReactComponent };